<template>
  <div class="border_8 p-4 rounded-lg">
    <div class="flex flex-row justify-between items-center">
      <label class="text-[15px] text_color font-semibold">{{ actionName }}</label>
      <a-switch
        :checked="modelValue || false"
        :disabled="disabled"
        size="small"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  actionName: { type: String, required: true },
  modelValue: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue"]);

const handleChange = (checked) => {
  emit("update:modelValue", checked);
};
</script>

